module.exports = __webpack_public_path__ + "img/logo_white.120e26cd.svg";